/**
 * @file Shell for the restore confirmation dialog (SYD-2450 phase 2): owns
 * `open` so antd drives the open/close transition, and nothing else.
 * `destroyOnHidden` unmounts `FormRecoveryConfirmModalContent` while closed, so
 * the pending-restore state and the `useFormRecoveryRestore` registration it
 * holds exist only while the dialog is on screen — mirroring
 * `FormAccessModal`/`FormAccessContent`.
 *
 * Mounted by `FormRecoveryGroup`'s "Restore" control. The three-column diff
 * table (field, value now, value being restored) and the Confirm/Cancel
 * actions live in the content component, which reads `formRecoveryStore`
 * itself rather than being handed the diff as a prop.
 */

import { FC } from 'react';
import { Modal } from 'antd';
import FormRecoveryConfirmModalContent from './FormRecoveryConfirmModalContent';

type FormRecoveryConfirmModalProps = {
  open: boolean;
  onClose: () => void;
};

const FormRecoveryConfirmModal: FC<FormRecoveryConfirmModalProps> = ({ open, onClose }) => (
  <Modal
    title="Restore this moment?"
    open={open}
    onCancel={onClose}
    footer={null}
    width={720}
    destroyOnHidden
  >
    <FormRecoveryConfirmModalContent onClose={onClose} />
  </Modal>
);

FormRecoveryConfirmModal.displayName = 'FormRecoveryConfirmModal';

export default FormRecoveryConfirmModal;
